let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9FBaW")).then(() => parcelRequire('7D93v'));